import type {
  ActionSpec,
  AppProfileWithId,
  AppSpec,
  AppStruct,
  ConnectorStruct,
  PerkIntegrationSpec,
  TriggerIntegrationSpec,
} from '@cohort/shared/schema/apps/app';
import {ListMediasActionSpec} from '@cohort/shared/schema/apps/instagram/actions/listMedias';
import type {InstagramMerchantConnectorStruct} from '@cohort/shared/schema/apps/instagram/merchantConnector';
import {InstagramMerchantConnectorSpec} from '@cohort/shared/schema/apps/instagram/merchantConnector';
import {InstagramCloseFriendsListPerkIntegrationSpec} from '@cohort/shared/schema/apps/instagram/perks/closeFriendsList';
import {InstagramCommentMediaTriggerIntegrationSpec} from '@cohort/shared/schema/apps/instagram/triggers/commentMedia';
import {InstagramConnectAccountTriggerIntegrationSpec} from '@cohort/shared/schema/apps/instagram/triggers/connectAccount';
import {InstagramTagInPostTriggerIntegrationSpec} from '@cohort/shared/schema/apps/instagram/triggers/tagInPost';
import type {OAuth2AppCredentials, OAuth2Credentials} from '@cohort/shared/schema/apps/oauth';
import {basicOauth2ConnectorSpec} from '@cohort/shared/schema/apps/oauth';

export type InstagramConnectorStruct = ConnectorStruct<
  'instagram',
  OAuth2AppCredentials,
  OAuth2Credentials,
  AppProfileWithId,
  null
>;

export const InstagramActionSpecs = [
  ListMediasActionSpec,
] as const satisfies ReadonlyArray<ActionSpec>;
type InstagramActionIds = (typeof InstagramActionSpecs)[number]['id'];

export const InstagramConnectorSpec =
  basicOauth2ConnectorSpec<InstagramConnectorStruct>('instagram');

export const InstagramPerkIntegrationSpecs = [
  InstagramCloseFriendsListPerkIntegrationSpec,
] as const satisfies ReadonlyArray<PerkIntegrationSpec>;
type InstagramPerkIntegrationIds = (typeof InstagramPerkIntegrationSpecs)[number]['id'];

export const InstagramTriggerIntegrationSpecs = [
  InstagramCommentMediaTriggerIntegrationSpec,
  InstagramConnectAccountTriggerIntegrationSpec,
  InstagramTagInPostTriggerIntegrationSpec,
] as const satisfies ReadonlyArray<TriggerIntegrationSpec>;
type InstagramTriggerIntegrationIds = (typeof InstagramTriggerIntegrationSpecs)[number]['id'];

export type InstagramAppStruct = AppStruct<
  'instagram',
  InstagramMerchantConnectorStruct,
  InstagramConnectorStruct,
  null,
  InstagramActionIds,
  never,
  InstagramPerkIntegrationIds,
  InstagramTriggerIntegrationIds,
  never,
  never
>;

export const InstagramAppSpec: AppSpec<InstagramAppStruct> = {
  id: 'instagram',
  name: 'Instagram',
  merchantConnector: InstagramMerchantConnectorSpec,
  userConnector: InstagramConnectorSpec,
  usersSyncSpec: null,
  actionSpecs: InstagramActionSpecs,
  notificationIntegrationSpecs: [],
  perkIntegrationSpecs: InstagramPerkIntegrationSpecs,
  triggerIntegrationSpecs: InstagramTriggerIntegrationSpecs,
  userEventSpecs: [],
  resourceSpecs: [],
};
